exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.card-container{padding:16px}.shipping{background-color:#e57373}.fee,.shipping{padding:10px 16px;border-radius:4px}.fee{background-color:#64b5f6}.card-title{font-size:18px;font-weight:700}.card-content,.card-title{text-align:center;display:block;width:100%}.card-content{margin-top:20px;font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fe1bba2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/deliveredReport.vue
// module id = 902
// module chunks = 0